import React, { createContext, useContext, useState, useEffect } from 'react';
import { getColors, getCommon } from './theme';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem('simbuilder-theme') || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('simbuilder-theme', mode);
    // Apply background to document so there's no flash of wrong colour
    document.body.style.backgroundColor = mode === 'dark' ? '#111827' : '#f0f2f5';
    // Expose the mode to CSS so global rules (e.g. focus rings) can adapt per theme
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  const toggleMode = () => setMode(prev => prev === 'dark' ? 'light' : 'dark');

  const colors = getColors(mode);
  const common = getCommon(colors);

  return (
    <ThemeContext.Provider value={{ mode, toggleMode, colors, common }}>
      {children}
    </ThemeContext.Provider>
  );
}

// Hook for easy access in any component
export function useTheme() {
  return useContext(ThemeContext);
}
